/* global google, storeLocator */
import './../mulberrys/store-locator';
import * as store_icon from '../../images/store_icon.png';

export default {
  init: function () {

    // eslint-disable-next-line no-undef
    const stores = ajax_vars.store_list;
    // eslint-disable-next-line no-undef
    const zipcodes =  ajax_vars.zip_codes;

    /**
     * extends storeLocator.StaticDataFeed
     * @constructor
     */
    function MulberrysDataSource() {

      $.extend(this, new storeLocator.StaticDataFeed);

      let stores_list = [];

      var url = new URL(window.location.href);
      var filter = url.searchParams.get("typeFilter");

      for (var i = 0; i < stores.length; i++) {

        if (filter === 'stores' && stores[i].is_locker) {
          continue;
        }

        if (filter === 'lockers' && ! stores[i].is_locker) {
          continue;
        }

        let position = new google.maps.LatLng(stores[i].lat, stores[i].lng);

        let store = new storeLocator.Store(stores[i].id, position, null, {
          title: stores[i].name,
          address: stores[i].address,
          phone: stores[i].contacts,
          url: stores[i].url,
          is_public: stores[i].is_public,
          is_locker: stores[i].is_locker,
          is_24hours : stores[i].is_24hours,
        });

        stores_list.push(store);

      }

      this.setStores(stores_list);
      this.setZipcodes(zipcodes);
    }

    var map;
    google.maps.event.addDomListener(window, "load", function () {

      map = new google.maps.Map(document.getElementById("map-canvas"), {
        center: new google.maps.LatLng(44.97189, -93.264227),
        zoom: 10,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControl: true,
        fullscreenControl : false,
      });

      // vars
      let bounds = new google.maps.LatLngBounds();
      // loop through all stores and create bounds
      $.each(stores, function (i) {

        let latlng = new google.maps.LatLng(stores[i].lat, stores[i].lng);

        bounds.extend(latlng);

      });

      // fit to bounds
      map.fitBounds(bounds);

      const panelDiv = document.getElementById("panel");

      const data = new MulberrysDataSource;

      const view = new storeLocator.View(map, data, {
        geolocation: true,
      });

      const panel_options = {
        view: view,
        locationSearchLabel: "",
        featureFilter: false,
        directions: false,
      };

      // eslint-disable-next-line no-undef
      if(typeof ajax_vars.nearest_store !== "undefined") {

        // eslint-disable-next-line no-undef
        let closest_store = ajax_vars.nearest_store;

        if (typeof closest_store !== "undefined") {

          closest_store = closest_store[0];

        } else {

          closest_store = false;

        }

        if (closest_store) {
          closest_store.address = closest_store.address.replace(/\n/g, ", ");
        }

        panel_options.store_search = {
          found: closest_store ? true : false,
          store: closest_store,
          // eslint-disable-next-line no-undef
          zip: ajax_vars.zip,
        };

      }

      new storeLocator.Panel(panelDiv, panel_options);

      var icons = {
        store: {
          name: "Store",
          icon: store_icon,
        },
        public: {
          name: "Public Lockers",
          icon: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
        },
        private: {
          name: "Private Lockers",
          icon: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
        },
        info: {
          name: "24/7 Lockers",
          icon: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
        },
      };

      var legend = document.getElementById('legend');
      legend.style.display = "none";
      for (var key in icons) {
        var type = icons[key];
        var name = type.name;
        var icon = type.icon;
        var div = document.createElement('div');
        div.innerHTML = '<img class="icons" src="' + icon + '"> ' + name;
        legend.appendChild(div);
      }

      map.controls[google.maps.ControlPosition.TOP_RIGHT].push(legend);
      legend.style.display = "block";

    });

    const openStoreInfoPanel = function() {
      const store_id_el = $(this).parent().attr("id");
      const store_id = store_id_el.split("-")[1];

      const store = stores.filter(function (obj) {

        return parseInt(obj.id) == parseInt(store_id);

      })[0];

      $(".info-panel-content").empty();

      const store_name_el = "<div class='store-name'><h3>" + store.name + "</h3></div>";

      let store_address = store.address;

      if (store.address2) {
        store_address = store_address + ", " + store.address2;
      }

      const store_address_el = '<div class="store-address"><i class="fas fa-map-marker"></i> ' + store_address + '</div>';

      const store_contacts = '<div class="store-contacts">' +
        '<div class="store-tel"><a href="tel:' + store.contacts + '"><i class="fas fa-phone"></i> ' + store.contacts + '</a></div>' +
        '<div class="store-get-directions"><a href="https://maps.google.com?saddr=Current+Location&daddr=' + store.address + '" target="_blank"><i class="fas fa-location-arrow"></i> Get Directions</a></div>' +
        '</div>';

      const store_separator_el = '<div class="separator"></div>';
      const store_view_store_el = '<div class="view-store"><a href="' + store.url + '" class="view-store-btn btn">View ' + store.name + ' Store</a></div>';

      $(".info-panel-content").append(store_name_el).append(store_address_el).append(store_contacts).append(store_separator_el).append(store_view_store_el);

      if(store.hours) {

        const store_hours_el = $('<div class="store-hours"><span>Hours </span><div class="hours"> ' + store.hours + '</div></div>');
        store_hours_el.insertAfter('.separator');
      }

      $(".info-panel").css({"margin-left": "0"});

    }

    $("body").on("click", ".info-icon", openStoreInfoPanel);
    $("body").on("click", "div.store", openStoreInfoPanel);

    $("body").on("click", ".close-icon", function (e) {

      e.preventDefault();
      $(".info-panel").css({"margin-left": "-100%"});
      $(".info-panel-content").empty();

    });

    // Select type filter handler
    var filterTypeLinks = $('#type-filter a');
    filterTypeLinks.on('click', function (event) {
      event.preventDefault();

      filterTypeLinks.removeClass('selected');
      this.classList.add('selected');
      // Force map refresh pins even if we selected a place. I tried other solutions, but they are not working
      map.setZoom(map.getZoom());
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/store-locator.js